// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "p[data-v-ea9f0dce]{word-break:break-word}", "",{"version":3,"sources":["webpack://./layouts/maintenance.vue"],"names":[],"mappings":"AAEA,mBACE,qBAAsB","sourcesContent":["\n\np {  \n  word-break: break-word;  \n\n}  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
